export const state = () => ({
  scroll: {
    isScrolling: false,
    limit: {
      x: 0,
      y: 0,
    },
    x: 0,
    y: 0,
  },
  move: {
    x: 0,
    y: 0,
  },
  sizes: {
    width: 0,
    height: 0,
  },
  device: {
    event: undefined,
  },
})

export const getters = {
  scroll: (state) => state.scroll,
}

export const mutations = {
  setScroll: (state, payload) => {
    state.scroll = Object.assign({}, state.scroll, payload)
  },
  setDevice: (state, payload) => {
    state.device = Object.assign({}, state.device, payload)
  },
  setSizes: (state, payload) => {
    state.sizes = Object.assign({}, state.sizes, payload)
  },
}
